import {isLocale,savedLocale,type Locale} from './languages';
import {translations} from './translations';
const normalized=new Map(Object.entries(translations).map(([source,values])=>[source.toLocaleLowerCase('vi'),values]));
// The development JSX runtime can be prebundled separately by Vite. Share locale
// state across both module graphs so a selection updates every rendered label.
const runtime=globalThis as typeof globalThis & {__nibelcLocale?:Locale};
runtime.__nibelcLocale??=typeof window==='undefined'?'vi':savedLocale();
export function currentLocale():Locale{return runtime.__nibelcLocale||'vi'}
export function activateLocale(value:Locale){if(isLocale(value))runtime.__nibelcLocale=value}
export function translate(text:string,locale:Locale=currentLocale()):string{
 if(locale==='vi'||!text.trim())return text;
 const key=text.trim().replace(/\s+/g,' '),punctuation=key.match(/[.:…]$/)?.[0]||'';
 const entry=translations[key]||normalized.get(key.toLocaleLowerCase('vi'))||(punctuation?normalized.get(key.slice(0,-1).toLocaleLowerCase('vi')):undefined);
 let translated=entry?.[locale];
 if(!translated)return text;
 if(punctuation&&!/[.!?:。…]$/.test(translated))translated+=punctuation;
 if(key===key.toLocaleUpperCase('vi')&&/[A-ZÀ-Ỹ]/.test(key))translated=translated.toLocaleUpperCase(locale);
 return (text.match(/^\s*/)?.[0]||'')+translated+(text.match(/\s*$/)?.[0]||'');
}
export function localizeProps(props:any){
 if(!props||currentLocale()==='vi')return props;
 const result={...props};
 const children=(value:any):any=>typeof value==='string'?translate(value):Array.isArray(value)?value.map(children):value;
 if('children' in result)result.children=children(result.children);
 for(const key of ['aria-label','aria-description','placeholder','title','alt','text','label','eyebrow','description'])if(typeof result[key]==='string')result[key]=translate(result[key]);
 return result;
}
